import HistoryPresentationVideoComponent from "./HistoryPresentationVideoComponent"

export default HistoryPresentationVideoComponent;